import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const navigate = useNavigate();

  // Get the current language
  const language = localStorage.getItem('language') || 'en';

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  const handleLearnMore = () => {
    navigate('/privacy-policy');
  };

  if (!showBanner) return null;

  const text = language === 'de' ? {
    message: 'Diese Website verwendet Cookies, um Ihnen das beste Erlebnis zu bieten.',
    learnMore: 'Mehr erfahren',
    reject: 'Ablehnen',
    accept: 'Annehmen'
  } : {
    message: 'This website uses cookies to provide you with the best experience.',
    learnMore: 'Learn more',
    reject: 'Reject',
    accept: 'Accept'
  };

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#2c2c2c',
        color: 'white',
        padding: '15px 20px',
        zIndex: 9999,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        fontSize: '14px',
        borderTop: '1px solid #444'
      }}
    >
      <div 
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '15px'
        }}
      >
        <div style={{ flex: '1', minWidth: '200px' }}>
          <span>{text.message} </span>
          <button
            onClick={handleLearnMore}
            style={{
              background: 'none',
              border: 'none',
              color: '#4CAF50',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: '0',
              fontSize: '14px'
            }}
          >
            {text.learnMore}
          </button>
        </div>
        
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <button
            onClick={handleReject}
            style={{
              backgroundColor: 'transparent',
              color: '#ccc',
              border: '1px solid #666',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#666';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#ccc';
            }}
          >
            {text.reject}
          </button>
          <button
            onClick={handleAccept}
            style={{
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              padding: '8px 20px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
          >
            {text.accept}
          </button>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#ccc',
              cursor: 'pointer',
              fontSize: '18px',
              padding: '4px 8px',
              lineHeight: '1',
              transition: 'color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.color = 'white'}
            onMouseOut={(e) => e.target.style.color = '#ccc'}
            title="Close"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;